import { defineStore } from "pinia";
import { cloneDeep, merge } from "lodash";
import api from "@/api";
import { useSettings } from "./settings";

const model = {
  code: null,
  name: null,
  description: null,
  logo: null,
  favicon: null,
  bgimage: null,
  privacy_cookie_code: null,
  disableFinal: false,
  mandator: {
    title: null,
    logo: null,
    type: null,
    referral: null,
    url: null
  } | null,
  context: {
    name: null,
    description: null,
    favicon: null,
    logo: null,
    urls: null
  },
};

export const useAccount = defineStore("account", {
  state: () => {
    return {
      current: cloneDeep(model),
      /** Account application data from profile service (logo, name, etc.) */
      accountApplicationFromProfile: null,
    };
  },
  actions: {
    setCurrent(item) {
      this.current = merge(this.current, item);
    },
    resetCurrent() {
      this.current = cloneDeep(model);
      this.accountApplicationFromProfile = null;
    },
    async init(contextApplicationId) {
      const item = await api.account.init(contextApplicationId);
      this.setCurrent(item);
      this.current.privacy_cookie_code = item.privacy_cookie_code;
      return item;
    },
    async fetchAccountApplication(applicationId) {
      if (!applicationId) return;
      const id = Number(applicationId);
      if (!id) return;
      try {
        let app = await api.application.get(id);
        if (app && typeof app === "object" && app.data !== undefined) app = app.data;
        this.accountApplicationFromProfile = app && typeof app === "object" ? app : null;
      } catch {
        this.accountApplicationFromProfile = null;
      }
    },
    /** Use init response as Account application (logo, name) when it contains application data */
    setAccountApplicationFromInitResponse() {
      const c = this.current;
      if (c && (c.id != null || c.code) && (c.logo != null || c.name != null)) {
        this.accountApplicationFromProfile = {
          id: c.id,
          code: c.code,
          name: c.name,
          description: c.description,
          logo: c.logo,
          favicon: c.favicon,
          uris: c.context?.urls ?? [],
        };
      }
    },
  },
  getters: {
    isExternalPlatformOrigin: (state) => {
      return state.current.code !== null && state.current.code !== useSettings().platformIdHeader;
    },
    hasValidMandator(state) {
      return (state.current.mandator != null)
    },
    hasValidLogo(state) {
      return (state.current.logo != null)
    },
    hasValidFavIcon(state) {
      return (state.current.favicon != null)
    },
    hasValidPrivacyCookieCode(state) {
      return (state.current.privacy_cookie_code != null)
    },
    /** Logo URL for the Account application from profile service (for header/public home) */
    accountApplicationLogo(state) {
      const logo = state.accountApplicationFromProfile?.logo;
      if (!logo || typeof logo !== "string") return null;
      if (logo.startsWith("http://") || logo.startsWith("https://") || logo.startsWith("data:")) return logo;
      const base = (import.meta.env.VITE_API_ENDPOINT || "").replace(/\/$/, "");
      const path = logo.startsWith("/") ? logo : `/${logo}`;
      return base ? `${base}${path}` : path;
    },
    hasAccountApplicationLogo(state) {
      return state.accountApplicationFromProfile?.logo != null;
    },
  }
});
